import { render, staticRenderFns } from "./ConferenceRedirect.vue?vue&type=template&id=046d4485"
import script from "./ConferenceRedirect.vue?vue&type=script&lang=js"
export * from "./ConferenceRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports